import React from 'react';

const TermsOfService = () => {
  const currentDate = new Date().toLocaleDateString('ar-EG', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });

  const styles = {
    container: {
      maxWidth: '800px',
      margin: '0 auto',
      padding: '20px',
      backgroundColor: '#ffffff',
      fontFamily: 'Arial, sans-serif',
      lineHeight: '1.8',
      color: '#333',
      direction: 'rtl',
      textAlign: 'right'
    },
    header: {
      textAlign: 'center',
      marginBottom: '40px',
      borderBottom: '3px solid #007bff',
      paddingBottom: '20px'
    },
    title: {
      fontSize: '2.5rem',
      fontWeight: 'bold',
      color: '#2c3e50',
      marginBottom: '10px'
    },
    lastUpdated: {
      color: '#666',
      fontSize: '0.9rem',
      fontStyle: 'italic'
    },
    notice: {
      backgroundColor: '#e3f2fd',
      border: '1px solid #2196f3',
      borderRight: '5px solid #2196f3',
      padding: '20px',
      marginBottom: '30px',
      borderRadius: '5px'
    },
    noticeTitle: {
      fontWeight: 'bold',
      color: '#1565c0',
      marginBottom: '10px'
    },
    section: {
      marginBottom: '30px'
    },
    sectionTitle: {
      fontSize: '1.5rem',
      fontWeight: 'bold',
      color: '#2c3e50',
      marginBottom: '15px',
      borderBottom: '2px solid #ecf0f1',
      paddingBottom: '5px'
    },
    paragraph: {
      marginBottom: '15px',
      textAlign: 'justify'
    },
    list: {
      marginRight: '20px',
      marginBottom: '15px'
    },
    listItem: {
      marginBottom: '8px'
    },
    highlight: {
      backgroundColor: '#fff3cd',
      border: '1px solid #ffeaa7',
      padding: '15px',
      borderRadius: '5px',
      marginBottom: '15px'
    },
    warning: {
      backgroundColor: '#f8d7da',
      border: '1px solid #f5c6cb',
      padding: '15px',
      borderRadius: '5px',
      marginBottom: '15px'
    },
    contact: {
      backgroundColor: '#f8f9fa',
      border: '1px solid #dee2e6',
      padding: '20px',
      borderRadius: '5px',
      textAlign: 'center'
    },
    contactTitle: {
      fontWeight: 'bold',
      marginBottom: '10px',
      color: '#495057'
    },
    link: {
      color: '#007bff',
      textDecoration: 'none'
    },
    strong: {
      fontWeight: 'bold',
      color: '#2c3e50'
    }
  };

  return (
    <div style={styles.container}>
      {/* Header */}
      <div style={styles.header}>
        <h1 style={styles.title}>شروط الخدمة</h1>
        <div style={styles.lastUpdated}>
          آخر تحديث: {currentDate}
        </div>
      </div>

      {/* Important Notice */}
      <div style={styles.notice}>
        <div style={styles.noticeTitle}>شروط بسيطة</div>
        <p>
          باستخدام تطبيق <strong>الدار العراقية</strong>، فإنك توافق على هذه الشروط البسيطة. 
          تطبيقنا هو خدمة إخبارية للقراءة فقط - لا يتطلب تسجيلاً أو بيانات شخصية.
        </p>
      </div>

      {/* Terms Content */}
      <div>
        
        {/* Section 1 */}
        <div style={styles.section}>
          <h2 style={styles.sectionTitle}>1. ما تقدمه خدمتنا</h2>
          <p style={styles.paragraph}>
            <span style={styles.strong}>الدار العراقية</span> هو تطبيق إخباري بسيط يوفر:
          </p>
          <ul style={styles.list}>
            <li style={styles.listItem}>أحدث المقالات الإخبارية والتحديثات</li>
            <li style={styles.listItem}>إشعارات الأخبار العاجلة (اختيارية)</li>
            <li style={styles.listItem}>محتوى إخباري سهل القراءة</li>
            <li style={styles.listItem}>إمكانية القراءة بدون إنترنت</li>
          </ul>
          <div style={styles.highlight}>
            <p><span style={styles.strong}>لا يتطلب تسجيلاً:</span> يمكنك استخدام تطبيقنا دون إنشاء حسابات أو تقديم معلومات شخصية.</p>
          </div>
        </div>

        {/* Section 2 */}
        <div style={styles.section}>
          <h2 style={styles.sectionTitle}>2. الاستخدام المقبول</h2>
          <p style={styles.paragraph}>
            تطبيقنا مصمم لقراءة المحتوى الإخباري. يرجى استخدامه بمسؤولية:
          </p>
          <ul style={styles.list}>
            <li style={styles.listItem}>استخدم التطبيق للأغراض الشخصية وغير التجارية</li>
            <li style={styles.listItem}>لا تحاول اختراق أو تعديل أو هندسة التطبيق عكسياً</li>
            <li style={styles.listItem}>لا تستخدم التطبيق لأي أنشطة غير قانونية</li>
            <li style={styles.listItem}>احترم حقوق الملكية الفكرية للمحتوى الإخباري</li>
          </ul>
        </div>

        {/* Section 3 */}
        <div style={styles.section}>
          <h2 style={styles.sectionTitle}>3. المحتوى والدقة</h2>
          <div style={styles.warning}>
            <p><span style={styles.strong}>إخلاء مسؤولية مهم:</span> بينما نسعى جاهدين لتقديم أخبار دقيقة ومحدثة، لا يمكننا ضمان أن جميع المعلومات دقيقة أو حالية أو مكتملة بنسبة 100%.</p>
          </div>
          <p style={styles.paragraph}>
            جميع المحتويات الإخبارية مملوكة لـ <span style={styles.strong}>الدار العراقية</span> أو مصادر المحتوى الخاصة بنا. 
            المحتوى محمي بموجب حقوق الطبع والنشر وقوانين الملكية الفكرية الأخرى.
          </p>
          <p style={styles.paragraph}>
            لا يجوز للمستخدمين إعادة نشر أو إعادة توزيع أو استخدام محتوانا للأغراض التجارية دون إذن.
          </p>
        </div>

        {/* Section 4 */}
        <div style={styles.section}>
          <h2 style={styles.sectionTitle}>4. توفر التطبيق</h2>
          <p style={styles.paragraph}>
            نحن نقدم التطبيق "كما هو" ولا يمكننا ضمان:
          </p>
          <ul style={styles.list}>
            <li style={styles.listItem}>العمل بنسبة 100% أو التوفر المستمر</li>
            <li style={styles.listItem}>التوافق مع جميع الأجهزة</li>
            <li style={styles.listItem}>التشغيل الخالي من الأخطاء</li>
            <li style={styles.listItem}>الخدمة المتواصلة دون انقطاع</li>
          </ul>
          <p style={styles.paragraph}>
            يمكننا تحديث أو تعديل أو إيقاف التطبيق في أي وقت دون إشعار مسبق.
          </p>
        </div>

        {/* Section 5 */}
        <div style={styles.section}>
          <h2 style={styles.sectionTitle}>5. الإشعارات الفورية</h2>
          <p style={styles.paragraph}>
            قد يرسل تطبيقنا إشعارات فورية للأخبار العاجلة والتحديثات المهمة:
          </p>
          <ul style={styles.list}>
            <li style={styles.listItem}>الإشعارات اختيارية ويمكن تعطيلها في إعدادات جهازك</li>
            <li style={styles.listItem}>لا نتتبع ما إذا كنت تقرأ الإشعارات أم لا</li>
            <li style={styles.listItem}>قد يختلف تكرار الإشعارات بناءً على الأحداث الإخبارية</li>
          </ul>
        </div>

        {/* Section 6 */}
        <div style={styles.section}>
          <h2 style={styles.sectionTitle}>6. الروابط الخارجية</h2>
          <p style={styles.paragraph}>
            قد يتضمن محتوانا الإخباري روابط لمواقع ويب خارجية. نحن لسنا مسؤولين عن:
          </p>
          <ul style={styles.list}>
            <li style={styles.listItem}>المحتوى في المواقع الخارجية</li>
            <li style={styles.listItem}>ممارسات الخصوصية للمواقع الأخرى</li>
            <li style={styles.listItem}>دقة المعلومات الخارجية</li>
          </ul>
        </div>

        {/* Section 7 */}
        <div style={styles.section}>
          <h2 style={styles.sectionTitle}>7. تحديد المسؤولية</h2>
          <p style={styles.paragraph}>
            <span style={styles.strong}>الدار العراقية</span> ومالكيها غير مسؤولين عن:
          </p>
          <ul style={styles.list}>
            <li style={styles.listItem}>أي أضرار من استخدام أو عدم القدرة على استخدام التطبيق</li>
            <li style={styles.listItem}>القرارات المتخذة بناءً على المحتوى الإخباري</li>
            <li style={styles.listItem}>المشاكل التقنية أو فقدان البيانات</li>
            <li style={styles.listItem}>أي أضرار غير مباشرة أو تبعية</li>
          </ul>
        </div>

        {/* Section 8 */}
        <div style={styles.section}>
          <h2 style={styles.sectionTitle}>8. تغييرات الشروط</h2>
          <p style={styles.paragraph}>
            قد نقوم بتحديث هذه الشروط من حين لآخر. سيتم نشر التغييرات في التطبيق وعلى موقعنا الإلكتروني. 
            الاستمرار في استخدام التطبيق يعني موافقتك على أي تغييرات.
          </p>
        </div>

        {/* Section 9 */}
        <div style={styles.section}>
          <h2 style={styles.sectionTitle}>9. القانون الحاكم</h2>
          <p style={styles.paragraph}>
            تخضع هذه الشروط لقوانين <span style={styles.strong}> العراق</span>. 
          </p>
        </div>

        {/* Contact Section */}
        <div style={styles.contact}>
          <div style={styles.contactTitle}>أسئلة حول هذه الشروط؟</div>
          <p>
            تواصل معنا على: <a href="mailto:[YOUR-EMAIL]" style={styles.link}>Panoiq@gmail.com</a><br/>
            العنوان: <span style={styles.strong}>العراق بغداد الكرخ
كرادة مريم قرب جسر الجمهورية
الفرع المقابل لوزارة التخطيط</span>
          </p>
          <p style={{marginTop: '10px', fontSize: '0.9rem', color: '#666'}}>
            نظراً لأن تطبيقنا لا يجمع بيانات شخصية، فإن معظم الأسئلة تتعلق بالمحتوى أو المسائل التقنية.
          </p>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;